module.exports = __webpack_public_path__ + "static/img/activity-20221208.6eacd9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20221208.png
// module id = O53m
// module chunks = 0